import React from "react";

// Composant réutilisable et évolutif : affiche une grille de cartes KPI.
// Chaque item : { label, value, sub, accent, testid }
export const KpiCard = ({ label, value, sub, accent, testid }) => {
  return (
    <div className="bg-sable rounded-sm border border-marine/10 p-4 card-lift" data-testid={testid}>
      <div className="text-xs uppercase tracking-wider text-marine/80 mb-1.5">{label}</div>
      <div className={`font-display text-xl leading-tight ${accent || "text-marine"}`}>{value}</div>
      {sub && <div className="text-xs text-marine/80 mt-1">{sub}</div>}
    </div>
  );
};

const COLS = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 lg:grid-cols-4",
  5: "grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
  6: "grid-cols-2 md:grid-cols-3 xl:grid-cols-6",
};

export default function KpiSummary({ items = [], className = "", testid }) {
  const valid = items.filter(Boolean);
  if (valid.length === 0) return null;
  const cols = COLS[Math.min(valid.length, 6)] || COLS[4];
  return (
    <div className={`grid ${cols} gap-3 stagger-children ${className}`} data-testid={testid}>
      {valid.map((it, i) => <KpiCard key={it.testid || i} {...it} />)}
    </div>
  );
}
